import { useQuery } from 'react-query';
import { Country } from '../../interfaces/customer.interface';
import { SORT_DIRECTION } from '../../interfaces/enumerables';
import { Error, GetEntities } from '../../interfaces/shared.interface';
import { apiRQ } from '../api';

export const getCountries = async (params: {
  page: number;
  orderBy: string;
  order: string;
  search?: string;
}): Promise<GetEntities<Country>> => {
  const resp = await apiRQ.get<GetEntities<Country>>('/countries', { params });

  return resp.data || [];
};

export const useCountries = (page: number, orderBy = 'id', order = SORT_DIRECTION.ASC, search: string) => {
  return useQuery<GetEntities<Country>, Error>(
    ['useCountries', page, orderBy, order, search],
    () => getCountries({ page, orderBy, order, search: search }),
    {
      cacheTime: 60000,
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  );
};
